import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Home, ListChecks, Contact2, TrendingUp, User, Bell } from "lucide-react";
import { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const NAV = [
  { to: "/app", label: "Home", icon: Home, end: true },
  { to: "/app/tasks", label: "Tasks", icon: ListChecks },
  { to: "/app/leads", label: "Leads", icon: Contact2 },
  { to: "/app/performance", label: "Performance", icon: TrendingUp },
  { to: "/app/profile", label: "Profile", icon: User },
];

export default function WorkerLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  useEffect(() => { api.get("/notifications").then((r) => setUnread(r.data.unread || 0)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="max-w-md mx-auto min-h-screen bg-[#F8FAFC] flex flex-col relative shadow-xl">
        <header className="sticky top-0 z-40 bg-white border-b border-slate-100 px-4 h-14 flex items-center justify-between">
          <Logo size="sm" to="/app" />
          <button onClick={() => navigate("/app/profile")} className="relative p-2" data-testid="worker-notif-btn">
            <Bell size={20} className="text-slate-600" />
            {unread > 0 && <span className="absolute top-1 right-1 h-4 min-w-4 px-1 rounded-full bg-[#1D4ED8] text-[10px] font-bold text-white grid place-items-center">{unread}</span>}
          </button>
        </header>
        <main className="flex-1 px-4 py-5 pb-24 overflow-y-auto"><Outlet /></main>
        <nav className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t border-slate-100 grid grid-cols-5 z-40">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`worker-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2.5 text-[10px] font-medium transition-colors ${isActive ? "text-[#1D4ED8]" : "text-slate-400"}`}>
              {({ isActive }) => (<>
                <n.icon size={20} className={isActive ? "drop-shadow-[0_0_6px_rgba(255,87,34,0.5)]" : ""} />
                {n.label}
              </>)}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
